import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';

import TabBar from './TabBar';
import Footer from './Footer';
import Home from '../Home';

import './simulator.css';

class Simulator extends Component {
    componentDidMount() {
        if (this.props.match.params.projectId) {
            this.props.getProject(this.props.match.params.projectId, this.props.authToken);
        }
        if (this.props.match.params.token) {
            this.props.getTokenProject(this.props.match.params.token);
        }
    }
    render() {
        const {
            authToken,
            projectName,
            toggleView,
        } = this.props;

        if (!authToken && !this.props.match.params.token) {
            return <Redirect to="/" />;
        }

        if (projectName) {
            return (
                <div>
                    { toggleView ? <Home /> : <TabBar /> }
                    <Footer {...this.props} token={this.props.match.params.token} />
                </div>
            );
        }
        return (
            <div>
                <p className="loading">Calculating your savings...</p>
            </div>
        );
    }
}

Simulator.propTypes = {
    authToken: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    projectToken: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    getProject: PropTypes.func.isRequired,
    getTokenProject: PropTypes.func.isRequired,
    toggleView: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    projectStreet: PropTypes.string.isRequired,
    projectStreet2: PropTypes.string.isRequired,
    projectCity: PropTypes.string.isRequired,
    projectZip: PropTypes.string.isRequired,
    projectState: PropTypes.number.isRequired,
};

Simulator.defaultProps = {
};

export default Simulator;



// WEBPACK FOOTER //
// ./src/containers/Simulator/Simulator.js